import { render, staticRenderFns } from "./deductBack.vue?vue&type=template&id=2901f5b6&"
import script from "./deductBack.vue?vue&type=script&lang=js&"
export * from "./deductBack.vue?vue&type=script&lang=js&"
import style0 from "./deductBack.vue?vue&type=style&index=0&id=2901f5b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports